import React from "react";
import Brightness5OutlinedIcon from "@mui/icons-material/Brightness5Outlined";
import NightlightOutlinedIcon from "@mui/icons-material/NightlightOutlined";
import { memo } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  getSettingState,
  setDarkMode,
} from "../../../../redux/features/settingSlice";

const ThemeBtn = memo(({ StyleMenuItem, setAnchorEl }) => {
  const dispatch = useDispatch();
  const { darkMode } = useSelector(getSettingState);

  const handleDarkTheme = () => {
    dispatch(setDarkMode(!darkMode));
    localStorage.setItem("darkMode", JSON.stringify(!darkMode));
    setAnchorEl(null);
  };

  return (
    <StyleMenuItem onClick={() => handleDarkTheme()}>
      {darkMode ? (
        <Brightness5OutlinedIcon sx={{ mb: "3px", mr: "8px" }} />
      ) : (
        <NightlightOutlinedIcon sx={{ mb: "3px", mr: "8px" }} />
      )}
      {darkMode ? "Light mode" : "Dark mode"}
    </StyleMenuItem>
  );
});

export default ThemeBtn;
